
export enum InstanceColumn {
  TENANT = 'tenant',
  STATUS = 'status',
  TYPE = 'type'
}

export const instanceColumns = Object.values(InstanceColumn) as string[];
